/** 1.4.0 portal strings, stream G2 (assigning a whole group for delivery): keys under groupAssign. if any. G2's file. */
export const GROUPS_G2_STRINGS = {} as const;
